import { useRef, useCallback } from 'react';

export const useThrottleCallback = <T extends (...args: any[]) => void>(
    callback: T,
    delay: number = 500,
): ((...args: Parameters<T>) => void) => {
    const isThrottledRef = useRef(false);

    return useCallback(
        (...args: Parameters<T>) => {
            if (isThrottledRef.current) return;

            isThrottledRef.current = true;
            callback(...args);

            setTimeout(() => {
                isThrottledRef.current = false;
            }, delay);
        },
        [callback, delay],
    );
};
